<template>
  <StepItem
    format="form"
    title="Verify Company Admin Phone Number"
    :subtitle="'Code sent to ' + formatPhone(companyAccountCreateStore.phone)"
    @handle-prev-step="handlePrevStep"
    @handle-next-step="handleNextStep"
    can-go-to-prev-step
    :is-ready-for-next-step="companyAccountCreateStore.smsVerificationCode.length === 6"
  >
    <template v-slot:default>
      <FormVerificationCodeInput
        v-model="companyAccountCreateStore.smsVerificationCode"
      />
      <p class="text-sm text-slate-500 select-none text-center mt-8">
        Didn't receive a code?
        <b
          @click="requestNewVerificationCode"
          class="hover:underline cursor-pointer"
        >
          <span v-if="countdown !== 0" class="w-92"
          >Request again in {{ countdown }}s</span
          >
          <span v-else>Send new verification code</span>
        </b>
      </p>
    </template>
    <template v-slot:next-step-text> Verify Account</template>
  </StepItem>
</template>

<script setup>
import StepItem from "./StepItem.vue";
import FormVerificationCodeInput from "./FormVerificationCodeInput.vue";
import {onActivated, onMounted, ref} from "vue";
import {useCompanyAccountCreateStore} from "../stores/CompanyAccountCreateStore.js";
import {sendSMSVerificationCode} from "../helpers/CommonAccountFunctions.js";

const companyAccountCreateStore = useCompanyAccountCreateStore();
const isReadyForNextStep = ref(false);
const countdown = ref(0);

const emits = defineEmits(["complete", "prev-step"]);

const handleNextStep = () => {
  isReadyForNextStep.value = companyAccountCreateStore.validateStep5();
  if (isReadyForNextStep.value) {
    emits("complete", 1);
  }
};

const handlePrevStep = () => emits("prev-step");

const requestNewVerificationCode = () => {
  if (countdown.value !== 0) {
    toast.warning("Sending a new code in " + countdown.value + " seconds.");

    setTimeout(() => {
      requestNewVerificationCode();
    }, (countdown.value + 1) * 1000);

    return;
  }

  sendSMSVerificationCode(companyAccountCreateStore.phone, (success) => {
    if (success)  toast.success("Verification code sent!");
    else handlePrevStep();

    restartTimer();
  });
};

const restartTimer = () => {
  if (countdown.value === 0) countdown.value = 59;
  setTimeout(() => {
    countdown.value -= 1;
    if (countdown.value > 0) {
      restartTimer();
    }
  }, 1000);
};

const formatPhone = (value) => {
  if (!value) return "";
  let cleaned = value.toString();
  const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    cleaned = `${match[1] ? "(" : ""}${match[1]}${match[2] ? ") " : ""}${
      match[2]
    }${match[3] ? "-" : ""}${match[3]}`;
  } else {
    const match = cleaned.slice(-10).match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      cleaned =
        "+" +
        cleaned.slice(0, cleaned.length - 10) +
        " " +
        `${match[1] ? "(" : ""}${match[1]}${match[2] ? ") " : ""}${match[2]}${
          match[3] ? "-" : ""
        }${match[3]}`;
    }
  }
  return cleaned;
};

onActivated(() => requestNewVerificationCode());
onMounted(() => requestNewVerificationCode());
</script>
